import { Flex } from '@zillow/constellation';
import { Paragraph, Text } from '@zillow/constellation-10';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';
import SvgTreeline from '../../../../images/treeline-illustration.svg';
import { StyledCard, StyledIconChevronRightCircle, StyledImageForSvg } from './StyledComponents';
import SimpleCard from '../../../SimpleCard';

import type { ApplicationsSummary } from '../../interfaces';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
  updateMinModuleHeight?: () => void;
  applicationsSummary: ApplicationsSummary;
};

const ApplicationsSummaryCard = ({ applicationsSummary, displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  if (!applicationsSummary) {
    return null;
  }

  const {
    urlPath,
    remainingSummaryCount: { remainingCount, remainingCountNew },
  } = applicationsSummary;

  const Card = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? SimpleCard : StyledCard;
  const withChevron = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? true : false;
  const cursor = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? 'pointer' : 'normal';
  const marginBottomMediaQuery = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? 0 : { base: '600', lg: 0, xl: '600' };

  const handleCardClick = () => {
    window.router.updateLocation(urlPath);
  };

  return (
    <Card cursor={cursor} cardType="secondary" cardElevation={0} withChevron={withChevron} onClick={handleCardClick}>
      <Paragraph
        css={{ textStyle: { base: 'body-sm-bold', lg: 'body-bold' } }}
      >{`+ ${remainingCount} applications...`}</Paragraph>
      {remainingCountNew > 0 ? (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          Includes
          <Text textStyle="body-sm-bold" css={{ color: 'text.feedback.warning.hero' }}>
            {` ${remainingCountNew} new `}
          </Text>
          applications.
        </Paragraph>
      ) : (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          You&apos;ve reviewed them all
        </Paragraph>
      )}

      {displayType === VERTICAL_DISPLAY_TYPE.FULL && (
        <Flex display={{ default: 'none', xl: 'flex' }}>
          <StyledImageForSvg src={SvgTreeline} alt="background" />
          <StyledIconChevronRightCircle size="sm" />
        </Flex>
      )}
    </Card>
  );
};

export default ApplicationsSummaryCard;
